<template>
  <div class="businessDetail">
    <div class="oneline">
      <div class="oneItem">
        <span class="label"> 联系人姓名</span>
        <span class="text">{{merchantUserRealname}}</span>
      </div>
      <div class="oneItem">
        <span class="label"> 联系人手机</span>
        <span class="text">{{merchantUserCellphone}}</span>
      </div>
      <div class="oneItem">
        <span class="label"> 店铺名称</span>
        <span class="text">{{storeName}}</span>
      </div>
      <div class="oneItem">
        <span class="label"> 店铺在园区的店铺列表排序（数字越大越靠上）</span>
        <span class="text">{{storeListSequence}}</span>
      </div>
      <div class="oneItem">
        <div class="label">所在园区</div>
        <div class="rightInput">
          <!-- {{itsLocation}}
          {{itsLocationStr}} -->
          <span  v-for="(list,index) in parkWord" v-if="list.value==itsLocation">{{list.text}}</span>
          <!-- <select name="" id="" v-model="itsLocation" style="border:0" disabled="true" >
            <option :value="list.value" v-for="(list,index) in parkWord" :key="index">{{list.text}}</option>
          </select> -->
        </div>
      </div>
      <div class="oneItem">
        <span class="label"> 经度</span>
        <span class="text">{{storeLongitude}}</span>
      </div>
      <div class="oneItem">
        <span class="label"> 纬度</span>
        <span class="text">{{storeLatitude}}</span>
      </div>
      <div class="oneItem">
        <div class="label">主营类目</div>
        <span>{{mainCategory}}</span>
      </div>
      <div class="oneItem">
        <div class="label">价格区间</div>
        <div class="rightInput">
          <span>{{startPrice}}</span>-
          <span>{{endPrice}}</span>
        </div>
      </div>
      <div class="oneItem">
        <div class="label">营业时间</div>
        <span>{{openTime}}</span>
      </div>

      <div class="oneItem">
        <div class="label">店铺备注</div>
        <span>{{parkRemark}}</span>
      </div>
      <div class="oneItem">
        <div class="label">品牌名称</div>
        <span>{{brandName}}</span>
      </div>
      <div class="oneItem">
        <div class="label">所属公司</div>
        <span>{{byCompany}}</span>
      </div>
      <div class="oneItem">
        <div class="label">折扣</div>
        <span>{{discountInfo}}</span>
      </div>
      <div class="oneItem">
        <span class="label"> 店铺地址</span>
        <span class="text">{{proviceText}}{{cityText}}{{distText}}{{addressString}}</span>
      </div>

    </div>

    <div class="oneLine">
      <div class="label">店铺介绍</div>
      <span>{{parkDescribe}}</span>
    </div>
    <div class="oneline">
      <div class="label">店面照片</div>
      <div class="rightInput">
        <img :src="list.url" alt="" v-for="(list,index) in dianmianImgInfoArr_string" style="height: 100px;" class="bigImg">
      </div>
    </div>
    <div class="oneLine">
      <div class="label">品牌LOGO</div>
      <div class="rightInput">
        <img :src="list.url" alt="" v-for="(list,index) in logoImgInfoArr_string" style="height: 100px;"  class="bigImg">
      </div>
    </div>
    <div class="oneLine">
      <div class="label">店铺标签</div>
      <div class="rightInput">
        <tagSelect :value="storeTagDetail" :type="'store'" @clickItem="getTag_store" :showArea="'detail'"></tagSelect>
      </div>
    </div>
    <div class="oneLine">
      <div class="label">店面地图图标</div>
      <div class="rightInput">
        <tagSelect :value="parkOnMapIconDetail" :type="'map_store'" @clickItem="getTag_map" :showArea="'detail'"></tagSelect>
        <span v-if="!parkOnMapIconDetail">无</span>
      </div>
    </div>
    <div class="oneLine">
      <div class="label">店面图标在地图上层级排序（数字越大越靠上）</div>
      <div class="rightInput">
        {{storeListSequence}}
      </div>
    </div>



    <div class="oneLine">
      <!-- <div class="label">地图位置</div> -->
      <div class="rightInput">
        <div id="mapContainer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import addressSelect from '@/components/addressSelect'
  import {
    json,
    wordData,
    utils
  } from '@/common/common.js'
  import {
    ajaxPost,
    api
  } from '@/common/request.js'
  import AMap from 'AMap'
  export default {
    name: 'adminIndex',
    data() {
      return {
        optionsCategory: [],
        isLoading: "",
        storeName: "",
        storeMapSequence:"",
        storeListSequence:'',
        itsLocation: "",
        itsLocationStr:'',
        storeLongitude: "",
        storeLatitude: "",
        storeTag: "",
        storeTagDetail:'',
        parkOnMapIcon: '',
        parkOnMapIconDetail:'',
        merchantUserRealname: "",
        merchantUserCellphone: '',
        // parkImg: '门店照片',
        mainCategory: [],
        // mainCategoryArr:[],
        addressSelect: [],
        startPrice: "",
        list_tag_store: [],
        list_tag_item: [],
        endPrice: "",
        openTime: "",
        parkDescribe: "",
        parkWord: [],
        brandName: "",
        // brandLogo: "",
        byCompany: "",
        discountInfo: "",
        parkRemark: "",
        //
        imageType: '',
        uploadData: {},
        dianmianImgInfoArr_string: [], //存储图片名字和其后台返回的id
        logoImgInfoArr_string: [], //存储图片名字和其后台返回的id

        // ditu
        proviceText: "",
        cityText: '',
        distText: '',
        proviceId: "",
        cityId: '',
        distId: '',
        addressString: '', //详细地址
        // props: {
        //   lazy: true,
        //   lazyLoad(node, resolve) {
        //     console.log(node)
        //     const {
        //       level
        //     } = node;
        //     let nodeId = node.value || 0
        //     let arg = {
        //       parentId: nodeId
        //     }
        //     ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
        //       if (res.errorCode == 200) {
        //         let lists = res.data || [{
        //           region_id: node.value + 'mm',
        //           region_name: node.label
        //         }]
        //         // let lists=res.data
        //         let newArr = lists.map(function(item, index) {
        //           let buffer = {
        //             value: item.region_id,
        //             label: item.region_name,
        //             leaf: level >= 2,
        //           }
        //           return buffer
        //         })
        //         resolve(newArr);
        //       }
        //     }, function(res) {})

        //   }
        // }

      }
    },
    computed: {
      IMG_PREV() {
        return api.imgPrev
      },
      api() {
        return api
      },
      adminId() {
        return utils.getAdminId()
      },
    },
    components: {
      addressSelect
    },
    methods: {
      getTag_map(data) {
        this.parkOnMapIcon = data.join(",")
      },
      getTag_store(data) {
        this.storeTag = data.join(",")
      },
      exceedHandle() {
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        if (file.wwType == '11401') { //logo
          // this.logoImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.logoImgInfoArr_string = fileList;
        }
        if (file.wwType == '11301') { //dianmian
          // this.dianmianImgInfoArr_string=this.computeImgIdArrToString(fileList)
          this.dianmianImgInfoArr_string = this.dianmianImgInfoArr_string.filter(item => item.uid != file.uid);
        }
      },
      computeImgIdArrToString(fileList) {
        let idArr = []
        for (var i = 0; i < fileList.length; i++) {
          let oneItem = fileList[i]
          let str = oneItem.wwId
          let arr = str.split(",")
          for (var j = 0; j < arr.length; j++) {
            let smallItem = arr[j]
            idArr.push(smallItem)
          }

        }
        return idArr.join(",")
      },
      turnImgIdToJson(str) {
        console.log(str)
        let result = ''
        if (str) {
          let arr = str.split(",")
          let newArr = arr.map(function(item, index) {
            return JSON.parse(item)
          })
          console.log(newArr)
          result = JSON.stringify(newArr)
        } else {
          result = ""
        }
        console.log(result)
        return result

      },
      addImgSuccessHandle(res, file, fileList) { //自动上传成功以后的操作
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);
        if (res.errorCode == 200) {
          file.wwId = res.data
          file.wwType = this.imageType
          if (this.imageType == '11401') { //logo
            // this.logoImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.logoImgInfoArr_string = fileList
          }
          if (this.imageType == '11301') { //dianmian
            // this.dianmianImgInfoArr_string=this.computeImgIdArrToString(fileList)
            this.dianmianImgInfoArr_string = fileList
          }
        }

      },
      addImgClick(type) { //点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---' + type)
        if (type == 'logo') {
          this.imageType = 11401
          this.uploadData = {
            imageType: this.imageType,
            imageUserId: this.adminId,
          }
          // console.log(this.uploadData)
        }
        if (type == 'dianmian') {
          this.imageType = 11301
          this.uploadData = {
            imageType: this.imageType,
            imageUserId: this.adminId,
          }
          // console.log(this.uploadData)
        }
      },
      // 选择主图
      handleSelectMain(file, fileList) {
        console.log(file);
        this.dianmianImgInfoArr_string.forEach(item => {
          if (file.uid == item.uid) {
            item.isMain = true
          } else {
            item.isMain = false
          }
        })
      },
      submitClick() {
        let _this = this
        if (!this.merchantUserRealname) {
          _this.$message({
            message: "联系人姓名必填",
            type: 'error',
          });
          return false
        }
        if (!this.merchantUserCellphone) {
          _this.$message({
            message: "联系人手机号必填",
            type: 'error',
          });
          return false
        }
        if(!json.phoneReg.test(this.merchantUserCellphone)){
          _this.$message({
               message: "手机号格式不正确",
               type: 'error',
          });
          return false
        }
        if (!this.proviceId || !this.cityId) {
          _this.$message({
            message: "地址必填",
            type: 'error',
          });
          return false
        }
        if (!this.storeLongitude || !_this.storeLatitude) {
          _this.$message({
            message: "经纬度必填",
            type: 'error',
          });
          return false
        }
        if (!this.storeName) {
          _this.$message({
            message: "店铺名称必填",
            type: 'error',
          });
          return false
        }
        if (!this.itsLocation) {
          _this.$message({
            message: "店铺所在园区必选",
            type: 'error',
          });
          return false
        }

        let arg = {
          adminId: _this.adminId,
          storeName: _this.storeName,
          itsLocation: _this.itsLocation,
          storeLongitude: _this.storeLongitude,
          storeLatitude: _this.storeLatitude,
          storeTag: _this.storeTag||'',
          parkOnMapIcon: _this.parkOnMapIcon||'',
          merchantUserRealname: _this.merchantUserRealname,
          merchantUserCellphone: _this.merchantUserCellphone,
          parkImg: utils.turnImgIdToJson_main(_this.dianmianImgInfoArr_string),
          mainCategory: _this.mainCategory.join(","),
          startPrice: _this.startPrice,
          endPrice: _this.endPrice,
          openTime: _this.openTime,
          parkDescribe: _this.parkDescribe,
          brandName: _this.brandName,
          brandLogo: utils.turnImgIdToJson(_this.logoImgInfoArr_string),
          byCompany: _this.byCompany,
          discountInfo: _this.discountInfo,
          parkRemark: _this.parkRemark,
          "regionProvinceId": _this.proviceId,
          "regionProvinceString": _this.proviceText,
          "regionCityId": _this.cityId,
          "regionCityString": _this.cityText,
          "regionDistrictId": _this.distId,
          "regionDistrictString": _this.distText,
          addressString: _this.addressString
        }
        console.log(arg)
        ajaxPost('/store/updateStoreInfo', arg).then(function(res) {
          if (res.errorCode == 200) {
            _this.$message({
              message: "修改商家成功",
              type: 'success',
            });
            _this.$router.back()

          } else {

          }
        }, function(res) {})

      },
      handleChangeCategory(value) {
        console.log(value)
        this.mainCategory = value
      },
      getTagList(type) {
        let _this = this
        console.log(arg)
        let arg = {
          tagType: type
        }
        ajaxPost('/tag/tagList', arg).then(function(res) {
          if (res.errorCode == 200) {
            console.log(res)
            let keyname = 'list_tag_' + type
            _this[keyname] = res.data

          } else {

          }
        }, function(res) {})
      },
      initMap() {
        let _this = this
        let lng=_this.storeLongitude
        let lat=_this.storeLatitude
        let map = new AMap.Map('mapContainer', {
          center: [lng,lat ],
          resizeEnable: true,
          zoom: 14,
          viewMode: '3D' //使用3D视图
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function() {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })
        let marker = ''
        marker = new AMap.Marker({
          position: new AMap.LngLat(lng, lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          // icon: '//vdata.amap.com/icons/b18/1/2.png',
          // icon:'../assets/images/test/small.png'
        });
        // 将创建的点标记添加到已有的地图实例：
        map.add(marker);
      },
      back() {
        this.$router.back()
      },
      changeAddress(data) {
        // console.log(JSON.stringify(data))
        this.proviceId = data.proviceId
        this.proviceText = data.proviceText
        this.cityId = data.cityId
        this.cityText = data.cityText
        this.distId = data.distId
        this.distText = data.distText
      },
      getParam() {
        this.storeId = this.$route.params.id
      },
      getItsParkName(val){
        let _this=this
        let result=""
        _this.parkWord.forEach(function(item,index){
          console.log(item)
          if(item.value==val){
            result=item.text
            return false
          }
        })
        return result

      },
      getDetail() {
        let _this = this
        let args = {
          storeId: _this.storeId,
        }
        ajaxPost('/store/getStoreInfo', args).then(function(res) {
          console.log(res.data)
          if (res.data) {
            let resData = res.data
            _this.storeName = resData.storeName
            _this.itsLocation = resData.itsLocation
            _this.itsLocationStr = _this.getItsParkName(resData.itsLocation)
            _this.storeLongitude = resData.storeLongitude
            _this.storeLatitude = resData.storeLatitude
            _this.storeMapSequence=resData.storeMapSequence
            _this.storeListSequence=resData.storeListSequence

            _this.initMap()

            _this.storeTagDetail = resData.storeTag
            _this.storeTag= resData.storeTag
            _this.parkOnMapIcon = resData.parkOnMapIcon
            _this.parkOnMapIconDetail = resData.parkOnMapIcon
            _this.merchantUserRealname = resData.merchantUserRealname
            _this.merchantUserCellphone = resData.merchantUserCellphone
            try{
              _this.mainCategory =JSON.parse(resData.mainCategory).join(" 、 ")
            }catch(err){
              _this.mainCategory = resData.mainCategory
            }

            if (resData.priceRange) {
              let arr = resData.priceRange.split("-")
              _this.startPrice = arr[0]
              _this.endPrice = arr[1]
            }

            _this.openTime = resData.openTime
            _this.parkDescribe = resData.parkDescribe
            _this.brandName = resData.brandName
            _this.byCompany = resData.byCompany
            _this.discountInfo = resData.discountInfo
            _this.parkRemark = resData.parkRemark
            _this.proviceId = resData.regionProvinceId
            _this.addressString = resData.addressString
            _this.proviceText = resData.regionProvinceString
            _this.cityText = resData.regionCityString
            _this.cityId = resData.regionCityId
            _this.distId = resData.regionDistrictId
            _this.distText = resData.regionDistrictString
            // _this.addressArr = []
            // _this.addressArr.push(_this.proviceId)
            // _this.addressArr.push(_this.cityId)
            // if (_this.distId) {
            //   _this.addressArr.push(_this.distId)
            // }

            let parkImg = res.data.parkImg ? JSON.parse(res.data.parkImg) : [];
            console.log(parkImg);
            _this.dianmianImgInfoArr_string = parkImg.map(item => {
              return {
                name: item.imgId,
                url: _this.IMG_PREV + item.imageFiles.split(',')[0],
                wwId: item,
                wwType: 11301,
                isMain: item.isMain == 1 ? true : false,
              }
            })

            let brandLogo = res.data.brandLogo ? JSON.parse(res.data.brandLogo) : [];
            console.log(brandLogo);
            _this.logoImgInfoArr_string = brandLogo.map(item => {
              return {
                name: item.imgId,
                url: _this.IMG_PREV + item.imageFiles.split(',')[0],
                wwId: item,
                wwType: 11401,
                isMain: item.isMain == 1 ? true : false,
              }
            })
          }

        }, function(res) {})
      },
      // handleChangeAddress(value) { //更改地址
      //   console.log("地址change")
      //   let nodesObj = this.$refs['cascader'].getCheckedNodes()
      //   // console.log(nodesObj)
      //   var valueArr = nodesObj[0].path
      //   var TextArr = nodesObj[0].pathLabels
      //   console.log(valueArr)
      //   console.log(TextArr)
      //   // proviceText
      //   this.proviceId = valueArr[0]
      //   this.cityId = valueArr[1]
      //   this.distId = valueArr[2] && valueArr[2].length == 6 ? valueArr[2] : ''
      //   this.proviceText = TextArr[0]
      //   this.cityText = TextArr[1]
      //   this.distText = this.distId ? TextArr[2] : ''
      // },
      getParkWord() {
        let _this = this
        ajaxPost('/park/getParkList', {}).then(function(res) {
          if (res.data) {
            _this.parkWord = []
            _this.parkWord = res.data.map(function(item, index) {
              let buffer = {}
              buffer.value = item.park_id
              buffer.text = item.park_name
              return buffer
            })

          }
        }, function(res) {})
      },
      getCategoryWord() {
        let _this = this
        let args = {
          types: 1,
        }
        ajaxPost('/yijiajiaDataCategory/getDatasource', args).then(function(res) {
          if (res.data) {
            _this.optionsCategory = []
            var arr = res.data.product.list
            arr.forEach(function(item, index) {
              let obj = {
                value: item.dataName,
                label: item.dataName,
                children: []
              }
              var childArr = item.list
              childArr.forEach(function(item2, index2) {
                let childBuffer = {
                  value: item2,
                  label: item2,
                }
                obj.children.push(childBuffer)
              })
              _this.optionsCategory.push(obj)
            })


          }
        }, function(res) {})
      },
      // getDetail() {
      //   let _this = this
      //   let args = {
      //     userId: _this.userId,
      //   }
      //   ajaxPost('/admin/yijiajiaUserAuth/getUserAuthByAId', args).then(function(res) {
      //     if (res.data) {}

      //   }, function(res) {})
      // },

    },
    mounted() {
      let _this = this
      this.getParam()
      this.getParkWord()
      this.getCategoryWord()
      this.getDetail()
      // this.getTagList('store')
      // this.getTagList('item') //这个换成地图
    },
    destroyed() {

    }
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }

  #mapContainer {
    width: 1000px;
    height: 600px;
    border:1px solid #ddd;
  }
 select[disabled]{color:#333}
  .businessDetail {
    background: #fff;
    padding: 20px;
    padding-bottom: 100px;

    .label{display: inline-block;font-weight: bold;margin-right: 10px;}
    .oneline{margin-bottom: 20px;}
    .oneItem{display: inline-block;min-width: 33%;margin-bottom: 10px;}
    .rightInput{display:inline-block}
    .bigImg{height: 180px;width: auto;border:1px solid #eee;margin-right: 10px;}


  }
</style>



// WEBPACK FOOTER //
// src/pages/business/detail.vue